"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spaui = require("@tencent/spaui");

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Footer = /*#__PURE__*/function (_PureComponent) {
  _inherits(Footer, _PureComponent);

  function Footer(props) {
    var _this;

    _classCallCheck(this, Footer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Footer).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleSaveChange", function (event) {
      _this.setState({
        checked: !!event.target.checked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (event, value) {
      var _this$props = _this.props,
          getCharacterStringLength = _this$props.getCharacterStringLength,
          _this$props$storageNa = _this$props.storageNameMaxWordNumber,
          storageNameMaxWordNumber = _this$props$storageNa === void 0 ? 10 : _this$props$storageNa;
      var len = getCharacterStringLength(value) || 0;
      var helpBlock = '',
          status = '';

      if (len < 1) {
        status = 'error';
        helpBlock = '名称必须填写';
      } else if (len > storageNameMaxWordNumber) {
        status = 'error';
        helpBlock = '输入的名称达到最大字数限制';
      } else {
        status = '';
        helpBlock = '';
      }

      _this.setState({
        value: value,
        status: status,
        helpBlock: helpBlock
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
      var _this$props2 = _this.props,
          onSubmit = _this$props2.onSubmit,
          _this$props2$defaultS = _this$props2.defaultStorageData,
          defaultStorageData = _this$props2$defaultS === void 0 ? {} : _this$props2$defaultS,
          _this$props2$storageA = _this$props2.storageArrivalLimit,
          storageArrivalLimit = _this$props2$storageA === void 0 ? false : _this$props2$storageA;
      var _this$state = _this.state,
          checked = _this$state.checked,
          _this$state$value = _this$state.value,
          value = _this$state$value === void 0 ? '' : _this$state$value;
      var disabled = storageArrivalLimit && !defaultStorageData.checked;
      onSubmit(event, {
        isNeedStorage: !disabled && checked,
        storageName: value
      });
    });

    var _props$defaultStorage = props.defaultStorageData,
        _defaultStorageData = _props$defaultStorage === void 0 ? {} : _props$defaultStorage;

    _this.state = {
      checked: _defaultStorageData.checked || false,
      value: typeof _defaultStorageData.storageName !== 'undefined' ? _defaultStorageData.storageName : '自定义列',
      status: '',
      helpBlock: ''
    };
    return _this;
  } // 打开保存开关


  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          onCancel = _this$props3.onCancel,
          _this$props3$defaultS = _this$props3.defaultStorageData,
          defaultStorageData = _this$props3$defaultS === void 0 ? {} : _this$props3$defaultS,
          getCharacterStringLength = _this$props3.getCharacterStringLength,
          _this$props3$storageA = _this$props3.storageArrivalLimit,
          storageArrivalLimit = _this$props3$storageA === void 0 ? false : _this$props3$storageA,
          onDelateStorage = _this$props3.onDelateStorage,
          _this$props3$storageN = _this$props3.storageNameMaxWordNumber,
          storageNameMaxWordNumber = _this$props3$storageN === void 0 ? 10 : _this$props3$storageN,
          submitLabel = _this$props3.submitLabel,
          cancelLabel = _this$props3.cancelLabel,
          storableTip = _this$props3.storableTip,
          storableLabel = _this$props3.storableLabel;
      var _this$state2 = this.state,
          value = _this$state2.value,
          checked = _this$state2.checked,
          status = _this$state2.status,
          helpBlock = _this$state2.helpBlock;
      var disabled = storageArrivalLimit && !defaultStorageData.checked;
      var valueLen = getCharacterStringLength(value);
      var formTips = '';

      if (!disabled) {
        formTips = _react["default"].createElement("span", {
          className: "a-form-tips"
        }, storableTip);
      } else {
        formTips = _react["default"].createElement("span", {
          className: "a-form-tips"
        }, "\u8BBE\u7F6E\u5DF2\u8FBE\u4E0A\u9650\uFF0C\u5982\u9700\u7EE7\u7EED\u6DFB\u52A0\u8BF7\u5148", _react["default"].createElement("a", {
          className: "a-link-primary",
          href: "javascript:",
          onClick: onDelateStorage
        }, "\u5220\u9664"));
      }

      return _react["default"].createElement("div", {
        className: "modal-footer-inner"
      }, _react["default"].createElement("div", {
        className: "modal-footer-left"
      }, _react["default"].createElement("div", {
        className: "a-form-inline"
      }, _react["default"].createElement(_spaui.FormGroup, null, _react["default"].createElement(_spaui.Checkbox, {
        checked: checked,
        onChange: this.handleSaveChange,
        disabled: defaultStorageData.disabled || disabled
      }, storableLabel)), !disabled && checked ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_spaui.FormGroup, {
        feedback: _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("span", {
          className: "spaui-input-feedback-count"
        }, valueLen), _react["default"].createElement("span", {
          className: "spaui-input-feedback-divider"
        }, "/"), _react["default"].createElement("span", {
          className: "spaui-input-feedback-range"
        }, storageNameMaxWordNumber)),
        helpBlock: helpBlock,
        status: status
      }, _react["default"].createElement(_spaui.Input, {
        size: "small",
        value: value,
        onChange: this.handleInputChange
      })), formTips) : formTips)), _react["default"].createElement("div", {
        className: "modal-footer-right"
      }, _react["default"].createElement(_spaui.Button, {
        onClick: onCancel
      }, cancelLabel), _react["default"].createElement(_spaui.Button, {
        disabled: !disabled && checked && (valueLen < 1 || valueLen > storageNameMaxWordNumber),
        bsStyle: "primary",
        onClick: this.handleSubmit
      }, submitLabel)));
    }
  }]);

  return Footer;
}(_react.PureComponent);

Footer.defaultProps = {
  // 取消函数
  onCancel: _lodash["default"].noop,
  // 确定函数
  onSubmit: _lodash["default"].noop,
  //默认的数据
  defaultStorageData: {}
};
var _default = Footer;
exports["default"] = _default;